<template>
  <div>
    <h2 class="step-name">Beef Disease</h2>

    <div class="step-section">
      <h3>Historic Testing</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Month</th>
            <th>Animal</th>
            <th>Vet</th>
            <th>Test Type</th>
            <th>Description</th>
            <th>Animals Tested</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('beef_bvd_results')" :key="index">
            <td class="text-left">{{ row['Month'] }}</td>
            <td class="text-left">{{ row['Animal'] }}</td>
            <td class="text-left">{{ row['Vet'] }}</td>
            <td class="text-left">{{ row['Test Type'] }}</td>
            <td class="text-left">{{ row['Description'] }}</td>
            <td class="text-left">{{ row['Animals Tested'] }}</td>
            <td class="text-left">{{ row['Result'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <h3>BVD Vaccination Purchases</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Animal Name</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
            <th>Doses</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('beef_bvd_vax_purchases')" :key="index">
            <td class="text-left">{{ row['Purchase Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Stock Code - Name'] }}</td>
            <td class="text-left">{{ row['Quantity'] }}</td>
            <td class="text-left">{{ row['Doses'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <radio-input
        label="Do you want to survey your herd for BVD (15 bloods):"
        field-name="beef_wants_bvd_survey"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <radio-input
        label="Do you want to BVD blood test bulls for certification?"
        field-name="beef_wants_bvd_test_bulls"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <div class="row">
        <div class="col-md-6">
          <h3>Tested</h3>
          <radio-input
            label="Replacement Heifers"
            field-name="beef_bvd_test_replacement_heifers"
            :choices="[
              { value: 'Yes', display: 'Yes' },
              { value: 'No', display: 'No' },
            ]"
          >
          </radio-input>

          <radio-input
            label="Bulls"
            field-name="beef_bvd_test_bulls"
            :choices="[
              { value: 'Yes', display: 'Yes' },
              { value: 'No', display: 'No' },
            ]"
          >
          </radio-input>

          <radio-input
            label="MA Cows"
            field-name="beef_bvd_test_ma_cows"
            :choices="[
              { value: 'Yes', display: 'Yes' },
              { value: 'No', display: 'No' },
            ]"
          >
          </radio-input>
        </div>

        <div class="col-md-6">
          <h3>Vaccinated</h3>

          <radio-input
            label="Replacement Heifers"
            field-name="beef_bvd_vax_replacement_heifers"
            :choices="[
              { value: 'Yes', display: 'Yes' },
              { value: 'No', display: 'No' },
            ]"
          >
          </radio-input>

          <radio-input
            label="Bulls"
            field-name="beef_bvd_vax_bulls"
            :choices="[
              { value: 'Yes', display: 'Yes' },
              { value: 'No', display: 'No' },
            ]"
          >
          </radio-input>

          <radio-input
            label="MA Cows"
            field-name="beef_bvd_vax_ma_cows"
            :choices="[
              { value: 'Yes', display: 'Yes' },
              { value: 'No', display: 'No' },
            ]"
          >
          </radio-input>
        </div>
      </div>

    </div>

    <div class="step-section">
      <div class="form-group">
        <span class="form-group">
          <label>General BVD comments</label>
          <comments field-name="general_bvd_comments"></comments>
        </span>
      </div>
    </div>

    <div class="step-section">
      <radio-input
        label="Would you like a BVD consult:"
        :add-email-notification="true"
        field-name="beef_wants_bvd_consult"
        @on-change="toggleNotification"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>
    </div>

    <div class="step-section">
      <h3>M.Bovis Impact</h3>
      <radio-input
        label="Was your farm impacted at any stage?"
        field-name="beef_previous_mbovis_impact"
        @on-change="toggleBeefHasMbovisImpact"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <radio-input
        label="If Yes are you still impacted?"
        field-name="beef_has_mbovis_impact"
        :disabled="disableBeefHasMbovisImpact"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <div class="form-group">
        <span class="form-group">
          <label>Comments</label>
          <comments field-name="m_bovis_impact"></comments>
        </span>
      </div>
    </div>

    <div class="step-section">
      <h3>Beef general vaccination Purchases</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Animal Name</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
            <th>Doses</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('beef_general_vax_purchases')" :key="index">
            <td class="text-left">{{ row['Purchase Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Stock Code - Name'] }}</td>
            <td class="text-left">{{ row['Quantity'] }}</td>
            <td class="text-left">{{ row['Doses'] }}</td>
          </tr>
        </tbody>
      </table>

      <div class="form-group">
        <span class="form-group">
          <label>Clostridial and Leptospirosis Vaccination</label>
          <comments field-name="clostridial_and_leptospirosis_vaccination"></comments>
        </span>
      </div>
    </div>

    <div class="step-section">
      <h3>Illness</h3>

      <div class="form-group">
        <span class="form-group">
          <label>Calf Health (prompt: calf scours, clostridial)</label>
          <comments field-name="calf_scours"></comments>
        </span>
      </div>

      <div class="form-group">
        <span class="form-group">
          <label>Lepto</label>
          <comments field-name="illness_lepto"></comments>
        </span>
      </div>

      <div class="form-group">
        <span class="form-group">
          <label>Metabolic</label>
          <comments field-name="illness_metabolic"></comments>
        </span>
      </div>

      <div class="form-group">
        <span class="form-group">
          <label>Cancer Eye</label>
          <comments field-name="illness_cancer_eye"></comments>
        </span>
      </div>

      <div class="form-group">
        <span class="form-group">
          <label>Bloat</label>
          <comments field-name="beef_is_bloat_issue"></comments>
        </span>
      </div>

      <div class="form-group">
        <span class="form-group">
          <label>Sudden Death (prompt: clostridial)</label>
          <comments field-name="illness_sudden_death"></comments>
        </span>
      </div>

      <div class="form-group">
        <span class="form-group">
          <label>Other</label>
          <comments field-name="illness_other"></comments>
        </span>
      </div>
    </div>

    <div class="step-section">
      <discussion-points
        title="Crop Feeding Discussion"
        comments-field="crop_feeding_discussion"
        points="Length on crop, transition, supplementation, water supply, phosphorus"
      >
      </discussion-points>
    </div>

    <drug-allocation-cart :drugGroups="getFieldValue('DRUG_GROUPS')" animalType="beef"> </drug-allocation-cart>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import DrugAllocationCart from './DrugAllocationCart'

export default {
  name: 'BeefDisease',
  mixins: [baseComponent],
  components: {
    DrugAllocationCart,
  },
  data() {
    return {
      disableBeefHasMbovisImpact: true,
    }
  },
  methods: {
    toggleNotification: function ({ fieldName, value }) {
      if (fieldName == 'beef_wants_bvd_consult') {
        this.setEmailNotification({ slug: 'would-you-like-a-bvd-consult', value: value == 'Yes' ? true : false })
      }
    },
    toggleBeefHasMbovisImpact: function ({ value }) {
      if (value == 'Yes') {
        this.disableBeefHasMbovisImpact = false
      } else {
        this.disableBeefHasMbovisImpact = true
      }
    },
  },
}
</script>
